<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.table">
  <div class="banner center" style="max-width:500px;" *ngIf="wrapper">
    <div class="row_header freeze_height">
      <div class="row" *ngIf="roots">
        <div class="col-12">
          <div *ngFor="let item of roots;index as i" style="float:left">
            <span *ngIf="item.v3 != '*'" [ngClass]="(roots.length - 1) > i ? 'button' : ''" style="font-weight:normal;" (click)="onRoute(item.key,(roots.length - 1) > i)">{{item.v3}}</span>
            <i *ngIf="item.v3 == '*'" [ngClass]="(roots.length - 1) > i ? 'button' : ''" style="font-weight:normal;" (click)="onRoute(item.key,(roots.length - 1) > i)" class="material-icons button icon_adjust">language</i>
            <span class="en">&nbsp;>&nbsp;</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          {{localService.languageContent.table.action}}
        </div>
        <div class="col-9">
          {{localService.languageContent.table.title}}
          <span class="en" *ngIf="wrapper">&nbsp;({{wrapper.length}})</span>
          <div class="icon_action_header">
            <i class="material-icons on_language_changed" (click)="onLoad()">replay_circle_filled</i>
            <i class="material-icons" (click)="openCreateEditPopup('')" title="{{localService.languageContent.common.add}}">note_add</i>
          </div>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of wrapper">
        <div class="col-3">
          <i class="material-icons button icon_adjust" title="{{item.v2 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v2 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v2 == '1' ? "toggle_on" : "toggle_off"}}</i>
          <a class="button" *ngIf="roots.length < 4" [routerLink]="['/locations' + localService.basicParamsString,item.key]"><i class="material-icons button icon_adjust">account_tree</i></a>
          <button type="button" class="button_icon button_icon_color" style="top: 5px !important;"  (click)="onGenerateRent(item.key)"
              title="{{localService.languageContent.common.generate_rent}}">play_arrow</button>
        </div>
        <div class="col-9">
          <span class="button" (click)="openCreateEditPopup(item.key)">{{item.v3}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
